import RegisterIcon from "./IconComponent/RegisterIcon";
import CarnetNoteIcon from "./IconComponent/CarnetNoteIcon";
import MenuIconTooltip from "./MenuIconTooltip";
import { REGISTER_WORKSPACE_MODES } from "../utils/registerWorkspacePreference";
import { MENU_MODE_TOOLTIPS } from "../constants/menuTooltips";
import { useHoverMenuOpen } from "../hooks/useHoverMenuOpen";

const ICON_SIZE = 50;

/**
 * Entrée menu Registre / Carnet de notes.
 * Le switch (pastille) n'apparaît qu'en survol lorsque la section est déjà active.
 */
export default function RegisterWorkspaceSwitch({
  workspaceMode = REGISTER_WORKSPACE_MODES.REGISTER,
  sectionActive = false,
  onEnterSection = () => {},
  onWorkspaceChange = () => {},
}) {
  const { open, setOpen, wrapRef, onMouseEnter, onMouseLeave } = useHoverMenuOpen(
    sectionActive
  );
  const isNotes = workspaceMode === REGISTER_WORKSPACE_MODES.NOTES;
  const ActiveIcon = isNotes ? CarnetNoteIcon : RegisterIcon;
  const InactiveIcon = isNotes ? RegisterIcon : CarnetNoteIcon;
  const inactiveWorkspace = isNotes
    ? REGISTER_WORKSPACE_MODES.REGISTER
    : REGISTER_WORKSPACE_MODES.NOTES;
  const activeTooltip = isNotes ? MENU_MODE_TOOLTIPS.notes : MENU_MODE_TOOLTIPS.register;
  const inactiveTooltip = isNotes ? MENU_MODE_TOOLTIPS.register : MENU_MODE_TOOLTIPS.notes;
  const expanded = sectionActive && open;

  const handleActiveClick = () => {
    if (!sectionActive) {
      onEnterSection();
    }
  };

  const handleInactiveClick = () => {
    onWorkspaceChange(inactiveWorkspace);
    setOpen(false);
  };

  return (
    <div
      ref={wrapRef}
      className={`register-workspace-menu-item${
        expanded ? " register-workspace-menu-item--open" : ""
      }`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {expanded ? (
        <div
          className="register-workspace-switch"
          role="group"
          aria-label="Choisir Registre ou Carnet de notes"
        >
          <MenuIconTooltip
            tooltip={activeTooltip}
            placement="below"
            portal
            arrow={false}
            className="register-workspace-switch__tip"
          >
            <button
              type="button"
              className="register-workspace-switch__option register-workspace-switch__option--active"
              onClick={handleActiveClick}
              aria-label={activeTooltip}
              aria-current="true"
            >
              <ActiveIcon size={ICON_SIZE} color="#39210d" strokeWidth={1} />
            </button>
          </MenuIconTooltip>
          <MenuIconTooltip
            tooltip={inactiveTooltip}
            placement="below"
            portal
            arrow={false}
            className="register-workspace-switch__tip"
          >
            <button
              type="button"
              className="register-workspace-switch__option"
              onClick={handleInactiveClick}
              aria-label={inactiveTooltip}
            >
              <InactiveIcon size={ICON_SIZE} color="#39210d" strokeWidth={1} />
            </button>
          </MenuIconTooltip>
        </div>
      ) : (
        <MenuIconTooltip
          tooltip={activeTooltip}
          placement="below"
          className={sectionActive ? "icon active" : "icon"}
        >
          <ActiveIcon
            size={ICON_SIZE}
            color="#39210d"
            strokeWidth={1}
            onClick={handleActiveClick}
            aria-label={activeTooltip}
          />
        </MenuIconTooltip>
      )}
    </div>
  );
}
